<div class="drafts-holder" [class.mobile]="isMobile" [class.has-open-drafts]="hasOpenDrafts">
  <ul class="drafts justify-content-end">
    @for (draft of drafts; track draft.draftId; let i = $index) {
      <li class="draft-item" [class.maximized]="draft.draftStatus === draftStatus.MAXIMIZED" [class.minimized]="draft.draftStatus === draftStatus.MINIMIZED">
        <div class="draft mat-elevation-z6" [class.centered]="!isMobile && userSettings?.centerDraftWindow === true" cdkDragBoundary=".drafts-holder" cdkDrag [cdkDragDisabled]="draft.draftStatus === draftStatus.MAXIMIZED || draft.draftStatus === draftStatus.MINIMIZED || isMobile">
          <div class="draft-header d-flex flex-row align-items-center justify-content-between" [class.draggable]="draft.draftStatus === draftStatus.OPEN" cdkDragHandle>
            <span class="text-truncate text-light">{{draft.draftTitle}} </span>
            <div class="mat-button-group ms-3 text-light">
              @if (draft.draftStatus === draftStatus.MINIMIZED) {
                <button mat-icon-button class="mini-icon-button" (click)="restoreDraft(draft.draftId, draft.draftType)"><mat-icon>maximize</mat-icon></button>
              }
              @if (draft.draftStatus !== draftStatus.MINIMIZED) {
                <button mat-icon-button class="mini-icon-button" (click)="minimizeDraft(draft.draftId, draft.draftType)"><mat-icon>minimize</mat-icon></button>
              }
              @if (draft.draftStatus !== draftStatus.MAXIMIZED) {
                <button mat-icon-button class="mini-icon-button" (click)="maximizeDraft(draft.draftId, draft.draftType)"><mat-icon>open_in_full</mat-icon></button>
              }
              @if (draft.draftStatus === draftStatus.MAXIMIZED) {
                <button mat-icon-button class="mini-icon-button" (click)="restoreDraft(draft.draftId, draft.draftType)"><mat-icon>close_fullscreen</mat-icon></button>
              }
              <button mat-icon-button class="mini-icon-button" (click)="closeDraft(draft.draftId, draft.draftType)"><mat-icon>close</mat-icon></button>
            </div>
          </div>
          <div class="draft-body">
            @if (draft.draftType.toLowerCase() === 'comment') {
              <app-create-comment [draft]="draft" #draftComponent></app-create-comment>
            }
            @if (draft.draftType.toLowerCase() === 'email') {
              <app-create-email [draft]="draft" #draftComponent></app-create-email>
            }
            @if (draft.draftType.toLowerCase() === 'message') {
              <app-create-message [draft]="draft" #draftComponent></app-create-message>
            }
            @if (draft.draftType.toLowerCase() === 'report') {
              <app-create-report [draft]="draft" #draftComponent></app-create-report>
            }
            @if (draft.draftType.toLowerCase() === 'script') {
              <app-create-script [draft]="draft" #draftComponent></app-create-script>
            }
          </div>
          <div class="draft-footer">
            <button mat-flat-button color="primary"
              [disabled]="isSaveButtonDisabled(draft.draftType, draft.draftId)"
              xuiConfirmationDialog
              [confirmMessage]="getSaveConfirmationMessage(draft.draftType)"
              (confirm)="saveCurrentDraft(draft.draftType, draft.draftId)"
              *xuiPermissionRequired="getSavePermission(draft.draftType)">
              {{ getSaveButtonLabel(draft.draftType) }}
            </button>
          </div>
        </div>
      </li>
    }
  </ul>
</div>

